export default "__VITE_ASSET__3bd9a6ab__"